<template>
  <div class="skin-profile-icon">
    <div class="skin-profile-icon__icon" :style="`color: ${iconColor};`">
      <fa :icon="icon" :type="iconType" />
    </div>
    <h4>{{ title }}</h4>
    <p class="skin-profile-icon__label">{{ label }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SkinProfileRow",

  props: {
    icon: {
      type: String,
      required: true
    },

    iconType: {
      type: String,
      required: false,
      default: "fas"
    },

    iconColor: {
      type: String,
      required: false,
      default: "#000"
    },

    title: {
      type: String,
      required: true
    },

    label: {
      type: String,
      required: true
    }
  }
});
</script>

<style lang="scss" scoped>
$icon-size: 1rem;

.skin-profile-icon {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 0.8rem;

  row-gap: 0.5rem;
}

.skin-profile-icon__icon {
  width: $icon-size;
  height: $icon-size;
}

.skin-profile-icon__label {
  flex-basis: 100%;
}
</style>
